import { Box, Divider, Typography } from "@mui/material";
import { Avatar } from "../../../../components/fieldsViews/fields/Avatar";
import { formatDateWithTime } from "../../../../utils/dateUtils";
import { displayEstimatedSessions } from "../../treatment-prescription/utils";

import type { LogbookPrescriptionItem } from "../../types";

type PrescriptionDetailPanelProps = {
	prescription: LogbookPrescriptionItem;
};

export const PrescriptionDetailPanel = ({ prescription }: PrescriptionDetailPanelProps) => {
	const dateLabel = formatDateWithTime(prescription.date_created);
	const servicesPrescribed = prescription.services_prescribed ?? [];

	return (
		<Box>
			<Typography variant="subtitle1" fontWeight="bold" color="primary.main">Prescrição</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>{dateLabel}</Typography>
			<Divider sx={{ my:4 }} />
			<Box sx={{ px: 2, mx: 2 }}>

			{prescription.user_created && (
				<Box sx={{ mb: 2 }}>
					<Typography variant="subtitle2" fontWeight="bold" color="primary.dark">Prescrito por</Typography>
					<UserWithAvatar user={prescription.user_created} />
				</Box>
			)}
			<Typography variant="subtitle2" fontWeight="bold" color="primary.dark" sx={{ mb: 1 }}>Serviços prescritos</Typography>
			{servicesPrescribed.map((sp: any, index: number) => (
				<Box key={index} sx={{ mb: 1.5, pl: 1 }}>
					<Typography variant="body1">{sp.service?.name}</Typography>
					{sp.estimated_total_sessions && (
						<Typography variant="body2" color="text.secondary">
							Sessões estimadas: {displayEstimatedSessions(sp.estimated_total_sessions, sp.service?.id)}
						</Typography>
					)}
				</Box>
			))}
						</Box>
		</Box>
	);
};

type UserWithAvatarProps = {
	user: { first_name?: string; last_name?: string; avatar?: string };
};

const UserWithAvatar = ({ user }: UserWithAvatarProps) => (
	<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
		<Avatar value={user.avatar} styles={{ width: 25, height: 25 }} />
		<Typography variant="body1">
			{user.first_name} {user.last_name}
		</Typography>
	</Box>
);
